import { useState } from "react";
var useLocalState = function (key, defaultValue) {
    var _a = useState(function () {
        var item = window.localStorage.getItem(key);
        try {
            if (item)
                return JSON.parse(item);
            else {
                window.localStorage.setItem(key, JSON.stringify(defaultValue));
                return defaultValue;
            }
        }
        catch (error) {
            window.localStorage.setItem(key, JSON.stringify(defaultValue));
            return defaultValue;
        }
    }), state = _a[0], _setState = _a[1];
    var setState = function (value) {
        if (typeof value === "function") {
            var f_1 = value;
            _setState(function (prevState) {
                var finalState = f_1(prevState);
                window.localStorage.setItem(key, JSON.stringify(finalState));
                return finalState;
            });
        }
        else {
            window.localStorage.setItem(key, JSON.stringify(value));
            _setState(value);
        }
    };
    return [state, setState];
};
export default useLocalState;
